export default __webpack_public_path__ + "static/media/image-cover.8f01f0f2.jpg";